import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints

const commonRequestParams = {
	credentials: "include",
	headers: {
		"Content-type": "application/json; charset=UTF-8",
	},
};
const commonQueryParams = {
	keepUnusedDataFor: 0,
	refetchOnFocus: true,
	refetchOnMountOrArgChange: true,
	async onQueryStarted(id, { dispatch, queryFulfilled }) {
		// `onStart` side-effect
		//dispatch(messageCreated('Fetching post...'))
		try {
			const { data } = await queryFulfilled;
			// `onSuccess` side-effect
			//   dispatch(messageCreated('Post received!'))
		} catch (err) {
			// `onError` side-effect
			//   dispatch(messageCreated('Error fetching post!'))
			console.error("my error from appAPI", err, queryFulfilled);

			/**
		err:{
				"error": {
					"status": 401,
					"data": {
						"error": "Unauthorized"
					}
				},
				"isUnhandledError": false,
				"meta": {
					"request": {},
					"response": {}
				}
		}
			 */
		}
	},
};
export const appAPI = createApi({
	reducerPath: "appAPI",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://rmstg.zeronetech.co.uk/api/",
		// prepareHeaders: (headers, { getState }) => {
		// 	// const token = getState().auth.token;

		// 	// If we have a token set in state, let's assume that we should be passing it.
		// 	// if (token) {
		// 	// headers.set("authorization", `Bearer ${token}`);
		// 	headers.set("Content-type", `application/json; charset=UTF-8`);
		// 	// }

		// 	return headers;
		// },
	}),
	tagTypes: [
		"Users",
		"User",
		"Roles",
		"Role",
		"Rooms",
		"Room",
		"settings",
		// "associations",
	],
	endpoints: (builder) => ({
		login: builder.mutation({
			query: (args) => {
				console.log("RTK", args);
				return {
					url: "sessions/login",
					method: "POST",
					body: args.body,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		logout: builder.mutation({
			query: () => {
				return {
					url: "sessions/logout",
					method: "DELETE",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		getDashBoard: builder.query({
			query: (args) => {
				return {
					url: "common/dashboard",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		// Users Related

		getUsers: builder.query({
			query: (args) => {
				return {
					url: "users",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			providesTags: ["Users"],
			...commonQueryParams,
		}),
		getUserById: builder.query({
			query: (args) => {
				console.log("RTK", args);
				return {
					url: "users/" + args.userId,
					method: "GET",
					...commonRequestParams,
				};
			},
			providesTags: ["User"],
			...commonQueryParams,
		}),
		createUser: builder.mutation({
			query: (args) => {
				console.log("RTK create User", args);
				return {
					url: "users",
					method: "POST",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["User", "Users"],
			...commonQueryParams,
		}),
		updateUser: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/" + args.userId,
					method: "PUT",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["User", "Users"],
			...commonQueryParams,
		}),
		deleteUser: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/" + args.userId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["Users"],
			...commonQueryParams,
		}),
		checkUserNameExists: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/name/" + args.username,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		checkEmailExists: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/email/" + args.email,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		resetUserPassword: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/" + args.userId + "/password",
					method: "POST",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		updateUserPassword: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "users/" + args.userId + "/password",
					method: "PATCH",
					body: { Password: args.password },
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		getRoles: builder.query({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			providesTags: ["Roles"],
			...commonQueryParams,
		}),
		createRole: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles",
					method: "POST",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["Roles", "Role"],
			...commonQueryParams,
		}),
		getRoleById: builder.query({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/" + args.roleId,
					method: "GET",
					...commonRequestParams,
				};
			},
			providesTags: ["Role"],
			...commonQueryParams,
		}),
		updateRole: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/" + args.roleId,
					method: "PUT",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["Roles", "Role"],
			...commonQueryParams,
		}),
		addPermissionToRole: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/" + args.roleId + "/allow",
					method: "POST",
					body: args.body,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		deleteRule: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/" + args.roleId + "/allow/" + args.ruleId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		deleteRole: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/" + args.roleId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["Roles"],
			...commonQueryParams,
		}),
		checkRoleNameExists: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "roles/name/" + args.roleName,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getResources: builder.query({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "resources",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getResourcesByType: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "resources/" + args.resourceType,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		getRooms: builder.query({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "rooms",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRoomById: builder.query({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "rooms/" + args.roomId,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		createRoom: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "rooms/",
					method: "POST",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["Room", "Rooms"],
			...commonQueryParams,
		}),
		updateRoom: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "rooms/" + args.roomId,
					method: "PUT",
					body: args.body,
					...commonRequestParams,
				};
			},
			invalidatesTags: ["Room", "Rooms"],
			...commonQueryParams,
		}),
		deleteRoom: builder.mutation({
			query: (args) => {
				//console.log("RTK", args);
				return {
					url: "rooms/" + args.roomId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["Rooms"],
			...commonQueryParams,
		}),
		checkRoomNameExists: builder.query({
			query: (args) => {
				return {
					url: "/rooms/name/" + args.roomName,
					method: "GET",
					...commonRequestParams,
				};
			},
			// providesTags: ["settings"],
			...commonQueryParams,
		}),

		pushBaseRecipe: builder.mutation({
			query: (args) => {
				return {
					url: "rooms/" + args.roomId + "/light/apply", // rooms/:Id/:recipetype/apply
					method: "POST",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		getSettings: builder.mutation({
			query: (args) => {
				return {
					url: "/settings",
					method: "GET",
					...commonRequestParams,
				};
			},
			providesTags: ["settings"],
			...commonQueryParams,
		}),

		setSettings: builder.mutation({
			query: (args) => {
				return {
					url: "/settings",
					method: "PATCH",
					body: args.body,
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["settings"],
			...commonQueryParams,
		}),

		getActivityLogs: builder.mutation({
			query: (args) => {
				return {
					url: "/activities",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		saveReport: builder.query({
			query: (args) => {
				return {
					url: "/common/light/savingsreport", //common/:recipetype/savingsreport
					method: "GET",
					params: args,
					responseHandler: (res) => res.text(),
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		getRecipes: builder.query({
			query: (args) => {
				return {
					url: "/recipes",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRecipeById: builder.query({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId,
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRecipeTypes: builder.query({
			query: () => {
				return {
					url: "/resources/recipe/types",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getLineTypesByRecipe: builder.query({
			query: (args) => {
				return {
					url: "/resources/recipe/" + args.recipeType + "/lineTypes",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRecipeTypeConfig: builder.query({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeType + "/config",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		createRecipe: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes",
					method: "POST",
					body: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		updateRecipe: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId,
					method: "PUT",
					body: args.body,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		deleteRecipe: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		recipeRoomAssociate: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId + "/association",
					method: "POST",
					body: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRecipesRoomsAssociation: builder.query({
			query: (args) => {
				return {
					url: "/recipes/" + "rooms" + "/associations",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			// providesTags: ["associations"],
			...commonQueryParams,
		}),
		deleteRecipesRoomsAssociation: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId + "/association/" + args.roomId,
					method: "DELETE",
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["associations"],
			...commonQueryParams,
		}),
		updateRecipesRoomsAssociation: builder.mutation({
			query: (args) => {
				return {
					url: "/recipes/" + args.recipeId + "/association/" + args.roomId,
					method: "PATCH",
					body: args.body,
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["associations"],
			...commonQueryParams,
		}),
		getActiveRecipesOfRoom: builder.query({
			query: (args) => {
				return {
					url: "/resources/room/" + args.roomId + "/activerecipes",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),
		getRecipeLineLookuptable: builder.query({
			query: (args) => {
				return {
					url:
						"/resources/recipe/" +
						args.recipeType +
						"/" +
						args.lineType +
						"/lookupTable",
					method: "GET",
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		appSearch: builder.query({
			query: (args) => {
				return {
					url: "/common/search",
					method: "GET",
					params: args,
					...commonRequestParams,
				};
			},
			...commonQueryParams,
		}),

		changeUserPassword: builder.mutation({
			query: (args) => {
				return {
					url: "users/" + args.userId + "/password",
					method: "PATCH",
					body: args.body,
					...commonRequestParams,
				};
			},
			// invalidatesTags: ["associations"],
			...commonQueryParams,
		}),
	}),
	// // Define onError callback to execute something on error for every request
	// onError: (error, { dispatch, getState }) => {
	// 	// Perform actions on error
	// 	console.error("An error occurred: my error", error);
	// 	// Optionally, dispatch actions or perform other error handling logic
	// },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation, useLogoutMutation } = appAPI;

export const { useLazyGetDashBoardQuery } = appAPI;

export const { useLazyAppSearchQuery, useChangeUserPasswordMutation } = appAPI;

export const {
	useGetUsersQuery,
	useGetUserByIdQuery,
	useCreateUserMutation,
	useUpdateUserMutation,
	useDeleteUserMutation,
	useCheckEmailExistsMutation, //
	useCheckUserNameExistsMutation, //
	useResetUserPasswordMutation,
	useUpdateUserPasswordMutation, //
} = appAPI;

export const {
	useGetRolesQuery,
	useCreateRoleMutation,
	useGetRoleByIdQuery,
	useLazyGetRoleByIdQuery,
	useUpdateRoleMutation,
	useAddPermissionToRoleMutation,
	useDeleteRoleMutation,
	useDeleteRuleMutation,
	useCheckRoleNameExistsMutation, //
	useGetResourcesQuery,
	useGetResourcesByTypeMutation,
} = appAPI;

export const {
	useGetRoomsQuery,
	useGetRoomByIdQuery,
	useLazyCheckRoomNameExistsQuery,
	useCreateRoomMutation,
	useUpdateRoomMutation,
	useDeleteRoomMutation,
	usePushBaseRecipeMutation,
} = appAPI;

export const {
	useGetSettingsMutation,
	useSetSettingsMutation,
	useGetActivityLogsMutation,
	useLazySaveReportQuery,
} = appAPI;

export const {
	useLazyGetRecipesQuery,
	useLazyGetRecipeByIdQuery,
	useLazyGetRecipeTypesQuery,
	useLazyGetLineTypesByRecipeQuery,
	useLazyGetRecipeTypeConfigQuery,
	useCreateRecipeMutation,
	useUpdateRecipeMutation,
	useDeleteRecipeMutation,
	useRecipeRoomAssociateMutation,
	useLazyGetRecipesRoomsAssociationQuery,
	useDeleteRecipesRoomsAssociationMutation,
	useUpdateRecipesRoomsAssociationMutation,
	useLazyGetActiveRecipesOfRoomQuery,
	useLazyGetRecipeLineLookuptableQuery,
} = appAPI;
